import { render, staticRenderFns } from "./VisitorAttractions2.vue?vue&type=template&id=81b64b28&scoped=true"
import script from "./VisitorAttractions2.vue?vue&type=script&lang=js"
export * from "./VisitorAttractions2.vue?vue&type=script&lang=js"
import style0 from "./VisitorAttractions2.vue?vue&type=style&index=0&id=81b64b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b64b28",
  null
  
)

export default component.exports